import { render, staticRenderFns } from "./UserFeatureRequestFeed.vue?vue&type=template&id=ee0726e4&scoped=true&"
import script from "./UserFeatureRequestFeed.vue?vue&type=script&lang=ts&"
export * from "./UserFeatureRequestFeed.vue?vue&type=script&lang=ts&"
import style0 from "./UserFeatureRequestFeed.vue?vue&type=style&index=0&id=ee0726e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0726e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
